var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlaze(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.53911 11.7047C2.53911 11.7047 3.4873 13.0977 5.47461 14.2768C5.47461 14.2768 4.03532 2.11261 13.4133 0C11.0106 8.81817 16.4695 11.305 18.4594 6.64622C21.7825 11.083 19.2594 14.9538 19.2594 14.9538C20.622 15.1501 21.7666 13.6615 21.7666 13.6615C21.7768 13.8449 21.7825 14.0295 21.7825 14.2155C21.7826 19.6193 17.4019 24 11.998 24C6.59408 24 2.21338 19.6193 2.21338 14.2154C2.21338 13.3474 2.327 12.506 2.53911 11.7047Z",
    fill: "url(#paint0_linear_2379_36426)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2379_36426",
    x1: 11.9979,
    y1: 0,
    x2: 11.9979,
    y2: 24,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#883DD2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF421D"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlaze);
export default __webpack_public_path__ + "static/media/blaze.34f8ced7e50b24088875cc2df744f07b.svg";
export { ForwardRef as ReactComponent };